import { useUpdateUserMetaDataMutation } from 'shared/hooks/queries/use-update-user-meta-data-mutation';

export const useUpdateUserMetaData = () => {
  const { mutate: updateMetaData } = useUpdateUserMetaDataMutation();

  return updateMetaData;
};
